export const ExclamationIcon = (props) => (
  <svg
    width={91}
    height={91}
    viewBox='0 0 91 91'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <circle
      cx={45.5}
      cy={45.5}
      r={45.5}
      fill='#E2E1F1'
    />
    <path
      d='M45.5 63.25c10.355 0 18.75-8.395 18.75-18.75S55.855 25.75 45.5 25.75 26.75 34.145 26.75 44.5s8.395 18.75 18.75 18.75m0-26.25v7.5m0 7.5h.019'
      stroke='#554DF1'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
